require("es6-promise").polyfill();

import Vue from "vue";
import Vuex from "vuex";
import platform from "./platform/index";
import cache from "./cache/index";
import menuState from "./platform/menuState";

Vue.use(Vuex);

const store = new Vuex.Store();

platform.forEach(function (item, index) {
  store.registerModule(item.name, item.data);
});

cache.forEach(function (item, index) {
  store.registerModule(item.name, item.data);
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js